<template>
  <div
    class="activator activator-iceberg"
    :style="`background-color: ${color}`"
    @mousedown="startMouseMove($event)"
    @mouseup="endMouseMove()"
  >
    <div class="activator-iceberg-object" />
  </div>
</template>
<script>
export default {
  props: ['color', 'value', 'css_variable', 'css_variable_negative', 'direction'],
  data: () => ({
    // set_value: false,
    initial_mouse_x: 0,
    initial_mouse_y: 0,
    // initial_width: 0,
    initial_value: 0,
    initial_value_negative: 0,
    new_width: 0,
    taktplan_zoom: 1,
  }),
  created(){
    // localStorage
    let new_value = localStorage.getItem(this.css_variable);
    let new_value_negative = localStorage.getItem(this.css_variable_negative);
    if (new_value) {
      document.body.style.setProperty(`${this.css_variable}`, new_value);
    }
    if (new_value_negative) {
      document.body.style.setProperty(`${this.css_variable_negative}`, new_value_negative);
    }
    this.$emit('resize');
  },
  methods: {
    startMouseMove(evt) {

      this.initial_mouse_x = evt.x;
      this.initial_mouse_y = evt.y;
      // this.initial_value = JSON.parse(JSON.stringify(this.value));
      this.initial_value = parseInt(getComputedStyle(document.body).getPropertyValue(`${this.css_variable}`));
      this.initial_value_negative = parseInt(getComputedStyle(document.body).getPropertyValue(`${this.css_variable_negative}`));
      this.taktplan_zoom = getComputedStyle(document.body).getPropertyValue('--taktplan_zoom');

      // this.set_value = true;
      // this.initial_width = parseInt(getComputedStyle(document.body).getPropertyValue('--project_taktplan_spatial_header_width'));
      document.body.addEventListener('mousemove', this.setValue);
      document.body.addEventListener('mouseup', this.endMouseMove);
    },
    endMouseMove() {
      // this.set_value = false;
      // document.body.style.setProperty('--project_taktplan_spatial_header_width', this.new_width);
      document.body.removeEventListener('mousemove', this.setValue);
      document.body.removeEventListener('mouseup', this.endMouseMove);
    },
    setValue(evt) {
      let difference = 0;
      if (this.direction === 'y') {
        difference = parseInt(this.initial_mouse_y - evt.y) / this.taktplan_zoom;
      } else {
        difference = parseInt(evt.x - this.initial_mouse_x) / this.taktplan_zoom;
      }

      let new_value = this.initial_value + difference
      let new_value_negative = this.initial_value_negative - difference

      // check if document body style has a property {css_variable}_min
      let min_value = parseInt(getComputedStyle(document.body).getPropertyValue(`${this.css_variable}_min`));
      if (min_value && new_value < min_value) {
        new_value = min_value;
        new_value_negative = this.initial_value_negative - (min_value - this.initial_value);
      }

      document.body.style.setProperty(`${this.css_variable}`, new_value);
      document.body.style.setProperty(`${this.css_variable_negative}`, new_value_negative);

      // localStorage
      if (this.css_variable) {
        localStorage.setItem(this.css_variable, new_value);
      }
      if (this.css_variable_negative) {
        localStorage.setItem(this.css_variable_negative, new_value_negative);
      }

      this.$emit('resize');
    }
  }
}
</script>
<style>
  .activator {
    position: absolute;
    height: 8px;
    width: 8px;
    border-radius: 100%;
    z-index: 2;
    background-color: var(--v-primary-base);
    transition: all 50ms ease-in-out;
  }
  .activator:hover {
    height: 20px;
    width: 20px;
  }
  .activator-train {
    position: absolute;
    height: 8px;
    width: 8px;
    border-radius: 100%;
    z-index: 2;
    background-color: var(--v-primary-base);
    transition: all 50ms ease-in-out;
  }
  .activator-train:hover {
    height: 20px;
    width: 30px;
    border-radius: 100% 5% 5% 5%;
  }
</style>
